export const colors = {
    black: '#000000',
    blueDark: '#2A4365',
    buttonHover: '#636B74',
    error: '#FDB3B3',
    grey: '#E0DFDF',
    greyBorder: '#D7D9DD',
    greyInputBorder: '#a7acb1',
    greyLight: '#EBEBEB',
    greyLightest: '#F8F8F8',
    greyMedium: '#AEACAC',
    greyDark: '#6E757D',
    greyDarker: '#555555',
    greyHighlight: '#F5F6F7',
    greenMedium: '#3E7673',
    greenDark: '#20494D',
    infoAlert: '#EBF8FF',
    offBlack: '#2B2E31',
    offWhite: '#F5F5F5',
    orange: '#FF5200',
    success: '#4CAF50',
    white: '#FFFFFF',
    open: '#6CB946',
    closed: '#E40000',
};
